import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

function Terms() {
  usePageMeta('Terms of Service', 'The terms that govern use of the Australia College website.');

  return (
    <section className="section">
      <div className="container legal">
        <span className="eyebrow">Legal</span>
        <h1>Terms of Service</h1>
        <p>Last updated: August 2026</p>

        <p>
          These terms govern your use of this website (the "Site"),
          operated by Australia College. Individual products (OneSchool
          Companion, Voceda, SMS Tutor) may be governed by their own terms
          at the point of use; this page covers the website itself.
        </p>

        <h2>Use of this site</h2>
        <p>
          This Site is provided to give visitors information about
          Australia College and its products. You agree to use it only for
          lawful purposes and not to attempt to disrupt, scrape at scale,
          or interfere with its normal operation.
        </p>

        <h2>Content</h2>
        <p>
          All text, graphics, and branding on this Site are the property of
          Australia College or their respective owners, unless otherwise
          noted, and may not be reproduced without permission.
        </p>

        <h2>Product availability</h2>
        <p>
          Some products described on this Site — including SMS Tutor and
          certain features of Voceda — are still in development. We aim to
          describe their status accurately (for example, using a "Coming
          soon" label), and availability, features, and timelines may
          change.
        </p>

        <h2>No warranty</h2>
        <p>
          This Site and its content are provided "as is". While we aim to
          keep information accurate and up to date, we make no guarantees
          about completeness or accuracy, and your use of the Site is at
          your own discretion.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the extent permitted by law, Australia College is not liable
          for any indirect or consequential loss arising from your use of
          this Site.
        </p>

        <h2>Changes to these terms</h2>
        <p>
          We may update these terms from time to time. Continued use of the
          Site after changes are posted means you accept the updated terms.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms can be sent through our{' '}
          <Link to="/contact">contact page</Link>.
        </p>
      </div>
    </section>
  );
}

export default Terms;
